(() => {
  const bar = document.querySelector('.cs26-booking-bar');
  const anchor = document.getElementById('appointment');
  if (!bar || !anchor) return;
  const form = anchor.closest('form') || anchor.parentElement.querySelector('form');
  if (bar.hasAttribute('data-reveal-after-intro')) {
    let frame = 0;
    const updateVisibility = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY || 0);
      const intro = document.querySelector('#main > .shopify-section');
      const introBottom = intro ? intro.getBoundingClientRect().bottom + y : 0;
      bar.hidden = y < Math.max(window.innerHeight, introBottom);
    };
    const scheduleVisibility = () => {
      if (!frame) frame = requestAnimationFrame(updateVisibility);
    };
    window.addEventListener('scroll', scheduleVisibility, {passive: true});
    window.addEventListener('resize', scheduleVisibility, {passive: true});
    window.addEventListener('pageshow', updateVisibility);
    window.addEventListener('load', updateVisibility, {once: true});
    updateVisibility();
  } else {
    bar.hidden = false;
  }
  bar.querySelector('a').addEventListener('click', event => {
    event.preventDefault();
    anchor.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    /* Addendum B (audit extern 10.09, F04): pe mobil nu mutăm focusul într-un câmp text (ar deschide tastatura);
       focus pe titlul secțiunii de formular, ca la DONNA/Riviera. */
    const section = (form && form.closest('.shopify-section')) || anchor.closest('.shopify-section');
    const heading = section && section.querySelector('.section-header h2, .section-header .h2, h2');
    const target = heading || form;
    if (target) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({preventScroll:true}); } catch (e) { /* noop */ }
    }
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      bar.toggleAttribute('data-form-visible', entries[0].isIntersecting);
    });
    observer.observe(form || anchor);
  }
})();
